module.exports = __webpack_public_path__ + "static/media/VIP_Message_Background@3x.63896ae0.png";